<script setup lang="ts">
  defineOptions({ name: 'H5App' })
</script>

<template>
  <router-view v-slot="{ Component }">
    <component :key="$route.fullPath" :is="Component" />
  </router-view>
</template>
